import { TextButton } from '@creditornot/cb-button';
import { Select } from '@creditornot/cb-select';
import * as R from 'ramda';
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { languageToPhraseKeyMap } from 'modules/shared-menu/constants';

type Props = {
  languages: Language[];
  onAdd: (language: string) => void;
};

const Root = styled.div`
  display: flex;
  align-items: center;
  margin-block-start: 26px;
`;

const StyledSelect = styled(Select)`
  width: 260px;
`;

const StyledButton = styled(TextButton)`
  margin-inline-start: 20px;
`;

const AddLanguage = ({ languages, onAdd }: Props) => {
  const intl = useIntl();
  const [selectedLanguage, setSelectedLanguage] = useState<string | null>(null);

  return (
    <Root>
      <StyledSelect
        placeholder={intl.formatMessage({ id: 'translation.selectNewTranslation' })}
        value={selectedLanguage}
        options={R.sortBy(l => l, languages).map(l => ({
          value: l,
          label: intl.formatMessage({ id: languageToPhraseKeyMap[l] }),
        }))}
        clearable={false}
        onChange={setSelectedLanguage}
      />
      <StyledButton onClick={() => selectedLanguage && onAdd(selectedLanguage)}>
        <FormattedMessage id="translation.addTranslation" />
      </StyledButton>
    </Root>
  );
};

export default AddLanguage;
